import { useMemo, useState } from 'react';
import styles from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import { getImageLocal } from '@/utils/locals';
import { createEFPic } from '@/utils/useEFPic';

const { EFPic } = createEFPic('/media/mm100/pc/modals/');

type IBatteriesTextProp = {
    className: string;
};

export default function BatteriesText({ className }: IBatteriesTextProp) {
    const { useLang, useRouter } = useGlobal();
    const { locale } = useRouter();
    const isShowBtn = ['us', 'eu', 'au', 'ca', 'uk', 'de', 'fr', 'cn', 'sa', 'it', 'es'].includes(locale);
    const [showText, setShowText] = useState(false);
    const { t } = useLang('ecoflowpowerkitsseries');

    const imgLocal = getImageLocal(locale, ['au', 'cn', 'za']);

    const content = useMemo(() => {
        switch (className) {
            case 'left':
                return (
                    <>
                        <p className="title">{t('presale.product.modals.LFPBatteries_ms1')}</p>
                        <div className="img">
                            <EFPic
                                name={['LFP-Batteries-1.webp', 'LFP-Batteries-1.png']}
                                className="fullImgs"
                                alt={t('presale.product.modals.LFPBatteries_ms1')}
                            />
                        </div>
                    </>
                );
            case 'right':
                return (
                    <>
                        <p className="title">{t('presale.product.modals.LFPBatteries_ms2')}</p>
                        <div className="img">
                            <EFPic
                                name={['LFP-Batteries-2.webp', 'LFP-Batteries-2.png']}
                                className="fullImgs"
                                alt={t('presale.product.modals.LFPBatteries_ms2')}
                            />
                        </div>
                    </>
                );
            case 'bottom':
                return (
                    <>
                        <p className="title title3">{t('presale.product.modals.LFPBatteries_ms3')}</p>
                        <div className="img">
                            <EFPic
                                name={[`LFP-Batteries-3_${imgLocal}.webp`, `LFP-Batteries-3_${imgLocal}.png`]}
                                className="fullImgs"
                                alt={t('presale.product.modals.LFPBatteries_ms3')}
                            />
                        </div>
                    </>
                );
            default:
                break;
        }
    }, [className]);

    const contentText = useMemo(() => {
        switch (className) {
            case 'left':
                return (
                    <div className={`batteries_pop top_left ${showText ? 'show' : ''}`}>
                        <h6>{t('presale.product.modals.LFPBatteries_ms4')}</h6>
                        <p>{t('presale.product.modals.LFPBatteries_ms4_desc')}</p>
                    </div>
                );
            case 'right':
                return (
                    <div className={`batteries_pop top_right ${showText ? 'show' : ''}`}>
                        <h6>{t('presale.product.modals.LFPBatteries_ms5')}</h6>
                        <p>{t('presale.product.modals.LFPBatteries_ms5_desc')}</p>
                    </div>
                );
            case 'bottom':
                return (
                    <div className={`batteries_pop bottom_text ${showText ? 'show' : ''}`}>
                        <h6>{t('presale.product.modals.LFPBatteries_ms6')}</h6>
                        <p>{t('presale.product.modals.LFPBatteries_ms6_desc')}</p>
                    </div>
                );
            default:
                break;
        }
    }, [className, showText]);

    const btnClass = () => {
        let name = 'btn';
        if (showText) name += ' btn_text';
        if (className === 'right') name += ' second';
        return name;
    };

    return (
        <div className={`${className} ${styles.batteries_text}`}>
            {content}
            {isShowBtn && (
                <div className={btnClass()} onClick={() => setShowText(!showText)}>
                    &times;
                </div>
            )}
            {contentText}
        </div>
    );
}
